export const REDUCER_NAME = 'barcode'




// WEBPACK FOOTER //
// ./src/modules/process/state/barcode/const.js